<template>
  <div class="">
    <div class="row justify-content-between">
      <div class="col-auto"></div>
      <div class="col-auto">
        <button
          @click="$router.push({ name: 'cold-rooms-create' })"
          class="btn btn-primary"
        >
          <i class="bi bi-plus-square"></i>
          Créer
        </button>
      </div>
    </div>
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Référence Nº</th>
          <th scope="col">Désignation</th>
          <th scope="col">Type</th>
          <th scope="col">Numéro de chambre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(coldroom, index) in coldrooms" :key="index++">
          <td>
            {{ index }}
          </td>
          <td>
            {{ coldroom.reference }}
          </td>
          <td>
            {{ coldroom.fullName }}
          </td>
          <td>{{ coldroom.type }}</td>
          <td>
            {{ coldroom.number }}
          </td>
          <td class="text-danger">
            <button
              @click="
                $router.push({
                  name: 'cold-rooms-temperatures',
                  params: { reference: coldroom.reference },
                })
              "
              class="btn"
            >
              <i class="bi bi-thermometer-half fs-5"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      search_value: "",
      addedToday: false,
      sortValue: "",
    };
  },
  computed: {
    ...mapGetters("coldroom", {
      coldrooms: "getColdrooms",
    }),
  },
  mounted() {
    this.$store.dispatch("coldroom/getAll");
  },
  methods: {
    async search(value) {
      return await this.$store.commit("coldroom/search", value);
    },
    async refresh() {
      return await this.$store.dispatch("coldroom/getAll");
    },

    async listColdrooms(checkbox) {
      if (checkbox == true) {
        console.log(checkbox);
        return await this.$store.commit("coldroom/getTodays");
      } else {
        return await this.$store.dispatch("coldroom/getAll");
      }
    },
    async sort(value) {
      return await this.$store.commit("coldroom/sort", value);
    },
  },
};
</script>
